// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__2T9kw","approved":"Status_approved__1Nmzh","rejected":"Status_rejected__2ObS9","expired":"Status_expired__3Ipqa","label":"Status_label__3DYMr"};